import { render, staticRenderFns } from "./TechesListPage.vue?vue&type=template&id=7378ba74&"
import script from "./TechesListPage.vue?vue&type=script&lang=ts&"
export * from "./TechesListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports